module.exports = __webpack_public_path__ + "img/elena_parkhaus_ocular.ab9f5cfb.jpg";